import { createClient } from '@supabase/supabase-js'

// Fonte unificada de variáveis de ambiente (browser + Node)
const viteEnv = (import.meta as any).env ?? {}
const nodeEnv = ((globalThis as any).process?.env ?? {}) as Record<string, string | undefined>
const ENV = { ...nodeEnv, ...viteEnv }

// Credenciais vêm só do ambiente (.env local / variáveis da Vercel); nada hardcoded
export const SUPABASE_URL =
  ENV.VITE_SUPABASE_URL ||
  ENV.NEXT_PUBLIC_SUPABASE_URL ||
  ENV.SUPABASE_URL

export const SUPABASE_ANON_KEY =
  ENV.VITE_SUPABASE_ANON_KEY ||
  ENV.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
  ENV.SUPABASE_ANON_KEY

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('[Config] VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY ausentes. Crie um .env a partir de .env.example.')
  throw new Error('Supabase URL/Anon key ausentes — configure .env')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
